import React from 'react';
import { Link } from 'react-router-dom';
import UnifiedFooter from '../../components/ui/UnifiedFooter';
import PublicNavigation from '../../components/ui/PublicNavigation';

const sections = [
  {
    id: 'collecte-des-donnees',
    title: '1. Collecte des données',
    content: (
      <>
        <p className="mb-3">
          <strong>ADT EXPRESS</strong> collecte certaines données personnelles dans le cadre de son activité,
          notamment via les canaux suivants :
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 pl-2 mb-4">
          <li>formulaires de contact sur le site</li>
          <li>suivi de colis et demandes de livraison</li>
          <li>échanges via WhatsApp</li>
          <li>création de compte client</li>
        </ul>
        <p className="mb-2">Les données susceptibles d'être collectées comprennent :</p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 pl-2">
          <li>nom et prénom</li>
          <li>numéro de téléphone</li>
          <li>adresse e-mail</li>
          <li>adresse postale</li>
          <li>informations relatives à la livraison (destination, nature des marchandises, etc.)</li>
        </ul>
      </>
    ),
  },
  {
    id: 'utilisation-des-donnees',title: '2. Utilisation des données',
    content: (
      <>
        <p className="mb-3">
          Les données personnelles collectées sont utilisées exclusivement dans le cadre de la relation
          commerciale avec nos clients. Elles servent à :
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 pl-2">
          <li>gérer et traiter les commandes d'expédition</li>
          <li>assurer le suivi des livraisons et informer le client de l'avancement</li>
          <li>communiquer avec le client (confirmations, notifications, réponses aux demandes)</li>
          <li>améliorer la qualité de nos services</li>
        </ul>
      </>
    ),
  },
  {
    id: 'conservation-des-donnees',title: '3. Conservation des données',
    content: (
      <p>
        Les données personnelles sont conservées uniquement le temps nécessaire à l'accomplissement des finalités pour lesquelles elles ont été collectées, c'est-à-dire pendant la durée de la relation
        commerciale et conformément aux obligations légales en vigueur. Au-delà de cette période, les
        données sont supprimées ou anonymisées.
      </p>
    ),
  },
  {
    id: 'partage-des-donnees',title: '4. Partage des données',
    content: (
      <>
        <p className="mb-3">
          <strong>ADT EXPRESS</strong> ne revend ni ne cède vos données personnelles à des tiers à des fins
          commerciales. Vos données peuvent être transmises uniquement aux partenaires strictement nécessaires
          à l'exécution de nos services :
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 pl-2 mb-4">
          <li>partenaires logistiques intervenant dans la chaîne d'expédition</li>
          <li>transporteurs chargés de la livraison</li>
          <li>autorités douanières, lorsque la réglementation l'exige</li>
        </ul>
        <div className="bg-green-50 border-l-4 border-green-700 pl-5 py-3 rounded-r-lg">
          <p className="text-green-900 text-sm font-medium">
            Aucune revente de données à des tiers à des fins publicitaires ou commerciales.
          </p>
        </div>
      </>
    ),
  },
  {
    id: 'securite',
    title: '5. Sécurité',
    content: (
      <p>
        <strong>ADT EXPRESS</strong> met en œuvre des mesures techniques et organisationnelles appropriées
        pour protéger vos données personnelles contre tout accès non autorisé, perte, altération ou
        divulgation. Ces mesures comprennent notamment un hébergement sécurisé des données et un accès
        limité aux seules personnes habilitées à les traiter dans le cadre de leurs fonctions.
      </p>
    ),
  },
  {
    id: 'droits-des-utilisateurs',
    title: '6. Droits des utilisateurs',
    content: (
      <>
        <p className="mb-3">
          Conformément au Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679),
          vous disposez des droits suivants concernant vos données personnelles :
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 pl-2 mb-4">
          <li><strong>Droit d'accès</strong> : obtenir une copie des données vous concernant</li>
          <li><strong>Droit de rectification</strong> : demander la correction de données inexactes ou incomplètes</li>
          <li><strong>Droit à l'effacement</strong> : demander la suppression de vos données personnelles</li>
        </ul>
        <p>
          Pour exercer ces droits, il vous suffit de nous contacter via les coordonnées disponibles sur
          notre site. Nous nous engageons à répondre à votre demande dans les meilleurs délais et au plus
          tard dans un délai d'un mois.
        </p>
      </>
    ),
  },
  {
    id: 'cookies',title: '7. Cookies',
    content: (
      <p>
        Le site ADT EXPRESS peut utiliser des cookies afin d'améliorer votre expérience de navigation,
        analyser l'audience du site et personnaliser certains contenus. Vous pouvez à tout moment
        configurer votre navigateur pour refuser les cookies ou être informé de leur dépôt. Le refus
        des cookies peut toutefois limiter certaines fonctionnalités du site.
      </p>
    ),
  },
  {
    id: 'responsable-du-traitement',title: '8. Responsable du traitement',
    content: (
      <>
        <p className="mb-3">
          Le responsable du traitement des données personnelles collectées via le site ADT EXPRESS est :
        </p>
        <address className="not-italic bg-gray-50 border-l-4 border-green-700 pl-5 py-4 rounded-r-lg space-y-1 text-gray-700">
          <p className="font-semibold text-gray-900">TRANSIMPEX INTERNATIONAL SERVICES</p>
          <p>Société par actions simplifiée unipersonnelle (SASU)</p>
          <p>RCS Bobigny : <strong>990 952 806</strong></p>
          <p>Siège social : 34 Rue Hémet, 93300 Aubervilliers, France</p>
          <p>
            Contact :{' '}
            <a
              href="mailto:contact@adtexpress.fr"
              className="text-green-700 hover:text-green-900 underline"
            >
              contact@adtexpress.fr
            </a>
          </p>
        </address>
      </>
    ),
  },
];

const PolitiqueDeConfidentialite = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PublicNavigation />
      <main className="flex-1">
        {/* Hero */}
        <div className="bg-green-900 text-white py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-green-300 text-sm font-medium mb-2 uppercase tracking-wider">
              Protection des données
            </p>
            <h1 className="text-3xl md:text-4xl font-bold">Politique de confidentialité</h1>
            <p className="mt-3 text-green-200 text-sm">
              Conformément au Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679).
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
          {/* Table of contents */}
          <nav className="mb-10 p-5 bg-gray-50 rounded-xl border border-gray-200">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
              Sommaire
            </p>
            <ol className="space-y-1">
              {sections?.map((s) => (
                <li key={s?.id}>
                  <a
                    href={`#${s?.id}`}
                    className="text-green-700 hover:text-green-900 text-sm hover:underline"
                  >
                    {s?.title}
                  </a>
                </li>
              ))}
            </ol>
          </nav>

          {/* Sections */}
          <div className="space-y-10">
            {sections?.map((s) => (
              <section key={s?.id} id={s?.id} className="scroll-mt-24">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                  {s?.title}
                </h2>
                <div className="text-gray-700 leading-relaxed text-sm md:text-base">
                  {s?.content}
                </div>
              </section>
            ))}
          </div>

          {/* Back link */}
          <div className="mt-14 pt-6 border-t border-gray-200">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-green-700 hover:text-green-900 font-medium"
            >
              ← Retour à l'accueil
            </Link>
          </div>
        </div>
      </main>
      <UnifiedFooter />
    </div>
  );
};

export default PolitiqueDeConfidentialite;
